export const reasons = [
  {
    index: 0,
    reason: 'Information Provided are Insufficient or are Incorrect',
    emailContent:
      "Your Profile details are incomplete. We would recommend you to fill in all the details correctly and complete your profile. Click on the right top corner of the screen => select 'my profile' => click on 'edit profile 'and you will be able to edit your profile.",
  },
];
